// ----------------------------------------------------------------------

export default function Table(theme) {
    return {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    // Public Sans' default figures are proportional, so digits
                    // in a column never line up. Tabular figures give every
                    // digit the same advance width. Letters are unaffected, so
                    // this is safe to apply to every cell rather than only the
                    // numeric ones.
                    fontVariantNumeric: 'tabular-nums',
                },
                head: {
                    // A column header is a label, not data: it sits one step
                    // below the body text at every density, and carries the
                    // weight instead of the size.
                    color: theme.palette.text.secondary,
                    backgroundColor: theme.palette.background.neutral,
                    fontSize: theme.typography.pxToRem(12),
                    fontWeight: theme.typography.fontWeightMedium,
                    lineHeight: 1.5,
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: { fontSize: theme.typography.pxToRem(13) },
                selectLabel: { fontSize: theme.typography.pxToRem(13) },
                displayedRows: { fontSize: theme.typography.pxToRem(13) },
                select: { fontSize: theme.typography.pxToRem(13) },
            },
        },
    };
}
